import { BigNumber, bn } from "@opensea/utils"

export function roundToken(
  value?: null | number | BigNumber,
  decimalPlaces = 4,
) {
  let newValue = value

  if (newValue === undefined || newValue === null) {
    return newValue
  }

  if (typeof newValue === "number") {
    newValue = bn(newValue)
  }

  if (newValue.absoluteValue().lt(1)) {
    return newValue
  }

  return newValue.decimalPlaces(decimalPlaces, BigNumber.ROUND_DOWN)
}
